var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExitFullscreen = function SvgExitFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9a1.5 1.5 0 0 0 1.5 1.5h5.25a.75.75 0 0 0 0-1.5H15V3.75a.75.75 0 0 0-1.5 0zM10.5 15A1.5 1.5 0 0 0 9 13.5H3.75a.75.75 0 0 0 0 1.5H9v5.25a.75.75 0 0 0 1.5 0zM10.5 9A1.5 1.5 0 0 1 9 10.5H3.75a.75.75 0 0 1 0-1.5H9V3.75a.75.75 0 0 1 1.5 0zM15 13.5a1.5 1.5 0 0 0-1.5 1.5v5.25a.75.75 0 0 0 1.5 0V15h5.25a.75.75 0 0 0 0-1.5z"
  })));
};
export default SvgExitFullscreen;